<template>
  <b-container fuid>
    <b-modal id="modal-profile-list" title="Account List" @ok="handleOk" @cancel="handleCancel">
      <div v-if="isStaffMember">
        <b-form-radio-group
          id="Profile"
          v-model="auth_level"
          :options="auth_level_list"
          @input="get_profile_list()"
          name="profile"
        />
        <br/>
        <b-input-group class="pb-2">
          <b-form-input class="mr-sm-2" placeholder="Account" v-model="critere" @keyup.enter="get_profile_list"/>
          <b-input-group-append>
            <b-button variant="outline-success" @click="get_profile_list">SEARCH</b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
      <b-table
        v-if="rows > 0"
        id="table-profile-list"
        primary-key="id"
        striped
        hover
        outlined
        table-variant="primary"
        head-variant="danger"
        :items="account_list"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        selectable
        select-mode="single"
        @row-selected="onRowSelected"
      >
      </b-table>
      <b-pagination
        v-show="rows > perPage"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
      <!--
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="success" @click="ok()">OK</b-button>
      -->
      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="danger" @click="cancel()">Cancel</b-button>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "modal-profile-list",
  computed: {
    ...mapState(["authLevel","auth_level_list","profile_list","current_profile","isStaffMember"]),
    rows() {
      return this.account_list.length;
    },
    account_list(){
      if (!this.isStaffMember) {
        return this.profile_list;
      } else if (this.auth_level == 4) {
        return this.carrier_list;
      } else if (this.auth_level == 6) {
        return this.consignee_list;
      } else {
        return [];
      }
    }
  },
  data() {
    return {
      critere: "",
      perPage: 10,
      currentPage: 1,
      selected_profile: {},
      carrier_list: [],
      consignee_list: [],
      auth_level: 0,
      fields: [
        { key: "id", label: "id" },
        { key: "name", label: "Name", sortable: true }
      ]
    };
  },
  methods: {
    onRowSelected(items) {
      this.selected_profile = items[0];
      this.handleSubmit();
    },
    get_profile_list() {
      switch(this.auth_level) {
        case 1:
          this.selected_profile.id = "DECSA";
          this.selected_profile.name = "DECSA Staff";
          this.selected_profile.type = 1;
          this.handleSubmit();
          break;
        case 4:
          this.perPage = 20;
          this.get_carrier_list();
          break;
        case 6:
          this.perPage = 10;
          if (this.critere != "") this.get_consignee_list();
          break;
        case 7:
          this.selected_profile.id = "PUBLIC";
          this.selected_profile.name = "PUBLIC";
          this.selected_profile.type = 7;
          this.handleSubmit();
          break;
      }
    },
    get_carrier_list() {
      let choicelist = true;
      let name = this.critere;
      this.$store.dispatch("get_carrier_list",{choicelist,name})
      .then((resp)=>{
        this.carrier_list = resp.data.carrier.map((x)=>{
            return {
              id: x.code,
              name: x.name,
              permission: this.current_profile.permission,
              type: 4
            };
          })
      })
      .catch(() => {
        this.carrier_list = [];
      });
    },
    get_consignee_list() {
      let choicelist = true;
      let customer_name = this.critere;
      this.$store.dispatch("get_consignee_list",{choicelist,customer_name})
      .then((resp)=>{
        this.consignee_list = resp.data.customer.map((x)=>{
            return {
              id: x.id,
              name: x.name,
              permission: this.current_profile.permission,
              type: 6
            };
          })
      })
      .catch(() => {
        this.consignee_list = [];
      });
    },
    handleCancel() {
      this.$nextTick(() => {
        this.$bvModal.hide(this.name);
      });
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      this.$store
      .dispatch("load_profile",this.selected_profile)
      .then(()=>{
        this.$bvModal.hide("modal-profile-list");
        const path = `/portal/dashboard`;
        if (this.$route.path !== path) {
          this.$router.push(path);
        } else {
          this.$store.dispatch("load_dashboard_data");
        }
      })
      .catch(()=>{
        this.$toast.warning("An error accurred. Please sign out and sign in again...");
      });
    }
  },
  created(){
    this.auth_level       = this.authLevel;
  },
};
</script>

<style scoped>
div {
  color: red;
}
</style>
